import { gql } from 'apollo-angular'

export const SampleControls = {
  fragments: {
    sampleControlGroups: gql`
            fragment sampleControlGroups on sampleControlGroups{
                id
                name
                code
                active
                v_
                matrix {
                    id
                    value
                }
               
            }`
  },
};

export const Get_AllSampleControls = gql`
 query GetAllSampleControls ($options: Options){
  sampleControlGroups (options: $options){
      data{
      ...sampleControlGroups
      }
      total,
      page,
      limit
    }
 }
${SampleControls.fragments.sampleControlGroups}`

export const Add_SampleControlGroup = gql`
mutation addSampleControlGroup($data: sampleControlGroupInput!) {
  addSampleControlGroup(data: $data) {
    ...sampleControlGroups
  }
}
${SampleControls.fragments.sampleControlGroups}`;

export const Get_SampleControlGroup = gql`
query GetSampleControlGroup($id: String!) {
  sampleControlGroup(id: $id) {
    ...sampleControlGroups
  }
}
${SampleControls.fragments.sampleControlGroups}`;

export const Update_SampleControlGroup = gql`
mutation updateSampleControlGroup($id: String!, $data: sampleControlGroupInput!) {
  updateSampleControlGroup(id: $id, data: $data) {
    ...sampleControlGroups
  }
}
${SampleControls.fragments.sampleControlGroups}`;

export const Remove_SampleControlGroup = gql`
  mutation RemoveSampleControlGroup($id: String!, $v_: Int!) {
    deleteSampleControlGroup(id: $id, v_: $v_) {
      id
    }
  }
`;

export const SampleControlGroupExists = gql`
query sampleControlGroupExists($code: String!) {
  sampleControlGroupExists(code: $code)
}
`;

export const Delete_ManySampleControlGroups = gql`
  mutation DeleteManySampleControlGroups($idsV_: [removeManySampleControlGroupsInput!]!) {
    removeManySampleControlGroups(idsV_: $idsV_) {
        deletedTasks {
        ...sampleControlGroups
    }
      errors
    }
  }
${SampleControls.fragments.sampleControlGroups}`;
